<template>
    <div>
        <vx-tooltip :text="$t('apps.configurator.style-button-tooltip')" position="top" delay=".3s" class="m-0">
            <vs-button type="border" class="mr-2 px-3 rounded-lg" @click="sendToStyleMenu">
                <div class="flex flex-nowrap">
                    <feather-icon icon="PenToolIcon" svgClasses="text-primary align-middle w-6" class="align-middle"/>
                </div>
            </vs-button>
        </vx-tooltip>
    </div>

</template>
<script>
export default {
    name:'configurator-edit-style-button',
    props: {
        properties: {type: Object,required: true}
    },
    methods:{
        sendToStyleMenu(){
            this.$router.push({name: 'styles', params: {"versionUuid": this.properties.uuid}});
        }
    },
}
</script>

<style scoped>
.action-button button {
    @apply h-12 !important;
}
</style>
